import GroupInheritedRestrictions from "./GroupInheritedRestrictions";
export default GroupInheritedRestrictions;
